import React, { ReactElement } from 'react'
import './Footer.scss'

export default class Footer extends React.Component {
  render(): ReactElement {
    return (
      <div className="footer">
        <div className="footer--credit">
          Powered by <span className="bold">Feedal inc.</span>
        </div>
      </div>
    )
  }
}
